
import React, { useState, useEffect, useMemo } from "react";
import Style from "./ProductItem.module.css";
import {
  faArrowLeft,
  faTrashAlt,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AllDiscountProductApi } from "../../Api/BarestSupplierServices";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import SwitchButton from "../SwitchButton/SwitchButton";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { separate } from "../../Functions/NumberSeprator";
import { deleteProductPostApi } from "../../Api/SupplierServices";

const ProductItem = ({ availables, index = 2, search, getProductDetail }) => {
  const [item, setItem] = useState(20);
  const [dateFilter, setDateFilter] = useState(null); // null, '24h', 'week', 'month'

  // ریست کردن تعداد آیتم‌های نمایشی با تغییر عبارت جستجو، دسته‌بندی یا فیلتر تاریخ
  useEffect(() => {
    setItem(20);
  }, [search, index, dateFilter]);

  // فیلتر و مرتب‌سازی محصولات:
  // اول بر اساس موجود/ناموجود، سپس بر اساس update_date به صورت نزولی (عدد بزرگتر اول)
  const filteredProducts = useMemo(() => {
    if (!availables || !Array.isArray(availables)) return [];
    return availables
      .filter((val) => {
        if (index === "1" && val.count === "0") {
          return false;
        } else if (index === "0" && val.count !== "0") {
          return false;
        }

        if (search && search.trim() !== "") {
          const query = search.trim().toLowerCase();
          const name = (val.name || "").toLowerCase();
          return name.includes(query);
        }

        // فیلتر بازه زمانی بروزرسانی
        if (dateFilter) {
          const days = val.update_date !== undefined && val.update_date !== null ? Number(val.update_date) : 0;
          if (dateFilter === "24h" && days >= 1) {
            return false;
          }
          if (dateFilter === "week" && days > 7) {
            return false;
          }
          if (dateFilter === "month" && days > 30) {
            return false;
          }
        }

        return true;
      })
      .sort((a, b) => {
        // ۱. ابتدا بر اساس موجودی (موجود اول بیاید)
        const aIsAvailable = a.count !== "0" && Number(a.count) > 0 ? 1 : 0;
        const bIsAvailable = b.count !== "0" && Number(b.count) > 0 ? 1 : 0;
        if (aIsAvailable !== bIsAvailable) {
          return bIsAvailable - aIsAvailable;
        }

        // ۲. سپس بر اساس update_date (عدد بیشتر اول بیاید)
        const aDate = Number(a.update_date) || 0;
        const bDate = Number(b.update_date) || 0;
        return bDate - aDate;
      });
  }, [availables, index, search, dateFilter]);

  //////////////////برداشتن تخفیف
  const deleteCategoryDiscount = (id) => {
    const Delete = {
      id: 0,
      product_id: id,
      const: 0,
      precentage: 0,
    };
    AllDiscountProductApi(Delete, (suc) => {
      if (suc.status === 1) {
        succToast("با موفقیت حذف شد ");
        getProductDetail(2);
      } else {
        errorToast("مشکلی پیش آمده");
      }
    });
  };
  //////////////حذف محصول
  const deletProductHandler = (productId) => {
    let info = {
      id: productId,
    };
    deleteProductPostApi(info, (res) => {
      getProductDetail(2);
    });
  };

  const hasMoreItems = item < filteredProducts.length;

  const loadMore = () => {
    if (item >= filteredProducts.length) return;
    setItem((prev) => prev + 20);
  };

  const subset = filteredProducts.slice(0, item);

  const formatUpdateTime = (dateVal) => {
    const days = dateVal !== undefined && dateVal !== null ? Number(dateVal) : 0;
    if (isNaN(days) || days < 1) {
      return "کمتر از ۲۴ ساعت گذشته";
    }
    return `${days} روز گذشته`;
  };

  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  return (
    <section className={Style.items}>
      <div className={Style.filterBar}>
        <div className={Style.filterChips}>
          <button
            type="button"
            className={`${Style.filterChip} ${dateFilter === "24h" ? Style.filterChipActive : ""}`}
            onClick={() => setDateFilter((prev) => (prev === "24h" ? null : "24h"))}
          >
            ۲۴ ساعت گذشته
          </button>
          <button
            type="button"
            className={`${Style.filterChip} ${dateFilter === "week" ? Style.filterChipActive : ""}`}
            onClick={() => setDateFilter((prev) => (prev === "week" ? null : "week"))}
          >
            هفته گذشته
          </button>
          <button
            type="button"
            className={`${Style.filterChip} ${dateFilter === "month" ? Style.filterChipActive : ""}`}
            onClick={() => setDateFilter((prev) => (prev === "month" ? null : "month"))}
          >
            ماه گذشته
          </button>
          {dateFilter && (
            <button
              type="button"
              className={Style.clearFilterBtn}
              onClick={() => setDateFilter(null)}
            >
              <FontAwesomeIcon icon={faTimes} style={{ marginLeft: "5px" }} />
              حذف فیلتر
            </button>
          )}
        </div>
      </div>
      <InfiniteScroll
        loadMore={loadMore}
        hasMore={hasMoreItems}
        loader={
          <PointSpreadLoading
            style={{ height: "3rem", marginInline: "auto" }}
            color={"#ab0c59"}
          />
        }
      >
        {subset.map((item) => {
            return (
              <div key={item.id} className={Style.eachItem}>
                <div className={Style.picPart}>
                  <div className={Style.picHolder}>
                    <img
                      src={`https://cdn.barest.ir/product/m/${item.id}.jpg?${randomNumberInRange(1, 1000000000000)}`}
                      alt=""
                    />
                  </div>
                  <div className={Style.textHolder}>
                    <h3 className={Style.name}>{item.name}</h3>
                    <h3 className={Style.count}>
                      تعداد: <span className={Style.num}>{item.count}</span>
                    </h3>
                    <h3 className={Style.updateTime}>
                      آخرین بروزرسانی:{" "}
                      <span className={Style.updateTimeText}>
                        {formatUpdateTime(item.update_date)}
                      </span>
                    </h3>
                    {item.off_price === "0" ? (
                      <div className={Style.priceHolder}>
                        <h3 className={Style.price}>
                          {separate(item.price)}
                          <span className={Style.toman}>تومان</span>
                        </h3>
                      </div>
                    ) : (
                      <div className={Style.priceHolder}>
                        <h3 className={Style.price}>
                          <span className={Style.toman}>
                            {separate(item.off_price)}
                          </span>
                          تومان
                        </h3>
                        <h3 className={Style.offPrice}>
                          {separate(item.price)}
                          <span className={Style.discount}>تومان</span>
                        </h3>
                      </div>
                    )}
                    {item.off_price === "0" ? (
                      <h3 style={{ display: "none",fontSize: ".8rem" }}> </h3>
                    ) : (
                      <h3
                        onClick={() => deleteCategoryDiscount(item.id)}
                        className={Style.delete}
                      >
                        حذف تخفیف
                      </h3>
                    )}
                  </div>
                </div>
                <div className={Style.deleteHolder}>
                  <FontAwesomeIcon
                    onClick={() => deletProductHandler(item.id)}
                    className={Style.trashIcon}
                    icon={faTrashAlt}
                  />
                </div>
                <div className={Style.Condition}>
                  <SwitchButton
                    item={item}
                    updateList={() => getProductDetail(2)}
                  />
                  {localStorage.getItem("type") === "food" ? (
                    <Link
                      to={{
                        pathname: `/editdetailproduct/${item.id}`,
                        state: { pId: item },
                      }}
                    >
                      <h4 className={Style.moreDetail}>
                        <FontAwesomeIcon
                          className={Style.icon}
                          icon={faArrowLeft}
                        />
                        ویرایش محصول
                      </h4>
                    </Link>
                  ) : (
                    <Link
                      to={{
                        pathname: `/editeproductsuppermarket/${item.id}`,
                        state: { data: item },
                      }}
                    >
                      <h4 className={Style.moreDetail}>
                        <FontAwesomeIcon
                          className={Style.icon}
                          icon={faArrowLeft}
                        />
                        ویرایش محصول{" "}
                      </h4>
                    </Link>
                  )}
                </div>
              </div>
            );
          })}
      </InfiniteScroll>
    </section>
  );
};
export default ProductItem;
